// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-UqX","right":"styles_right__2xCec"};